import React from 'react';
import { Link } from 'react-router-dom';
import '../scripts/useHoverEffect';
import DriverModal from '../components/DriverModal';
import '../css/mainlockup.css';
import '../css/driver-modal.css';
import '../css/main.css';
import DriverModalMobile from './DriverModalMobile';


const HomeMobileLayout: React.FC = () => {
    return (
    <div className='mobile-main-lockup'>
        <div className='main-lockup' id='hero-title-mobile'>
            <div className='main-lockup-text'>
                <h1> 
                Szukasz szybkiej i niezawodnej taksówki w Bochni?
                </h1>
                <h2>
                Oferujemy usługi taxi, dzięki którym zawsze bezpiecznie i komfortowo dotrzesz na czas!
                Zarezerwuj jednego z poniższych kierowców już teraz!
                </h2>
            </div>
        </div>

        <div className='driver-modal-container'>
        <DriverModalMobile driverIndex={1} />
        <DriverModalMobile driverIndex={2} />
        </div>

        <div className='main-lockup-services'>
        <h2>Wśród naszych dodatkowych usług znajdziesz również:</h2>
        <ul>
            <li>Transport na lotniska.</li>
            <li>Transport imprez okolicznościowych.</li>
            <li>Bezpieczny transport dla najmłodszych między placówkami edukacyjnymi a domem.</li>
        </ul>
        <p>
            Po więcej informacji zapraszamy na stronę <Link to="/services" className='custom-link'>usługi.</Link>
        </p>
        </div>
    </div>
    );
};

export default HomeMobileLayout